@import "~/src/common/screens";

.itemsBlockWrapper {
    text-align: center;
}

.foundBooks {
    font-weight: 600;
    margin: 20px 0;
}

.infoBlock {
    max-height: 120px;
    overflow: auto;
    height: 100%;
    max-height: 114px;

    overflow-y: auto;
}


.infoBlock::-webkit-scrollbar {
    width: 3px;
}

.infoBlock::-webkit-scrollbar-track {
    background: #f1f1f1; 
}

.infoBlock::-webkit-scrollbar-thumb {
    background: #c0c0c0; 
    border-radius: 5px;
}

.infoBlock::-webkit-scrollbar-thumb:hover {
    background: #999; 
}

.category, .authors {
    color: #808080;
}

.category {
    text-decoration: underline;
}

.thumbnail {
    display: block;
    margin: 5px auto;

    height: 100%;
    max-height: 230px;
    max-width: 100%;

    box-shadow: 8px 5px 8px 2px rgba(34, 60, 80, 0.3);
}

.noPhoto {
    box-shadow: none;
}

.itemsBlock {
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;

    margin-top: 30px;
}

.itemBlock {
    display: flex;
    flex-direction: column;
    text-align: start;
    
    gap: 20px;
    min-height: 340px;
    max-width: 300px;
    width: 100%;

    padding: 25px;
    border-radius: 10px;
    border: 0;

    background: #f5f5f5;
    cursor: pointer;
    transition: .3s ease;

    .imageWrapper {
        height: 70%;
        width: 100%;
    }

    &:focus-visible {
        box-shadow: 0 0 0 4px #a6bdee;
    }

    &:hover {
        box-shadow: 0px 5px 25px 0 rgba(34, 60, 80, 0.3);
    }
}

.loadMore {
    margin-top: 30px;
}



@media all and (min-width: 768px) {
    .itemsBlock {
        grid-template-columns: repeat(2, 1fr);
    }

    .itemBlock {
        font-size: 16px;
    }
}

@media all and (min-width: 992px) {
    .itemsBlock {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media all and (min-width: 1200px) {
    .itemsBlock {
        grid-template-columns: repeat(4, 1fr);
    }
}